import type { Translations } from '../keys';

const itIT: Translations = {
  'common.search': 'Cerca',
  'common.copied': 'Copiato',
  'common.copy': 'Copia',
  'common.poweredBy': 'Powered by',
  'common.plan': 'Piano',
  'common.banner': 'Banner',
  'common.total': 'Totale {value}',
  'common.installmentPrefix': '{count}x da',
  'common.discountCoupon': 'Codice sconto',
  'common.checkout': 'Pagamento',
  'common.tryAgain': 'Riprova',

  'app.loading': 'Caricamento del checkout…',
  'app.init.error': 'Errore durante l\'inizializzazione del pagamento:',

  'checkout.title': 'Completa il tuo abbonamento',
  'checkout.subtitle': 'Inserisci i tuoi dati per sbloccare l\'accesso a {productName}.',
  'checkout.greeting': 'Siamo felici di vederti, {firstName}',
  'checkout.contactInfo': 'Informazioni di contatto',
  'checkout.contact.namePlaceholder': 'Nome completo',
  'checkout.paymentMethod': 'Metodo di pagamento',
  'checkout.cardData': 'Dati della carta',
  'checkout.card.maskPlaceholder': '•••• •••• •••• ••••',
  'checkout.card.expMonth': 'Mese',
  'checkout.card.expYear': 'Anno',
  'checkout.card.cvv': 'CVV',
  'checkout.card.expiryPlaceholder': 'MM/AA',
  'checkout.card.holderName': 'Nome completo del titolare della carta',
  'checkout.document': 'Documento',
  'checkout.document.cpfHolder': 'CPF del titolare',
  'checkout.useFilledName': 'Usa il nome già inserito',
  'checkout.summary.ariaLabel': 'Riepilogo dell\'abbonamento',
  'checkout.summary.community': 'Community',
  'checkout.summary.availablePlans': 'Piani disponibili',
  'checkout.summary.chooseAccess': 'Scegli il tuo accesso',
  'checkout.summary.buying': 'Stai acquistando:',
  'checkout.summary.renewal': 'Si rinnoverà il {date}. Puoi annullare quando vuoi.',
  'checkout.theme.enableLight': 'Attiva il tema chiaro',
  'checkout.theme.enableDark': 'Attiva il tema scuro',
  'checkout.theme.light': 'Chiaro',
  'checkout.theme.dark': 'Scuro',
  'checkout.installments.title': 'Rateizzazione',
  'checkout.installments.placeholder': 'Numero di rate',
  'checkout.installments.discount': '{percent}% di sconto',
  'checkout.submit.generatePix': 'Genera codice PIX',
  'checkout.submit.buyLifetime': 'Acquista {productName} (accesso a vita)',
  'checkout.submit.subscribe': 'Abbonati a {productName}',
  'checkout.footer.safeTransaction': 'Transazione sicura e crittografata',
  'checkout.footer.termsPrefix': 'Confermando l\'acquisto, accetti i',
  'checkout.footer.terms': 'Termini di utilizzo di Ginastee',

  'checkout.notFound.eyebrow': 'Pagamento non disponibile',
  'checkout.notFound.title': 'Community non trovata',
  'checkout.notFound.description': 'Questo link di pagamento non corrisponde a una community attiva. Controlla l\'indirizzo o contatta la community.',

  'checkout.paymentsUnavailable.message': 'I pagamenti per la tua area non sono ancora disponibili: il responsabile della community deve completare la configurazione del wallet.',
  'checkout.paymentsUnavailable.action': 'Scopri come',

  'coupon.title': 'Codice sconto',
  'coupon.placeholder': 'Inserisci il codice',
  'coupon.notFound': 'Codice sconto non trovato',

  'pix.title': 'Completa il pagamento con PIX',
  'pix.instructions': 'Apri un\'app in cui hai il PIX abilitato e scegli l\'opzione "Paga", poi "Leggi QR Code"',
  'pix.scanQrCode': 'Scansiona il QR Code qui sotto nell\'app della tua banca',
  'pix.qrAlt': 'QR Code PIX',
  'pix.copyCode': 'Oppure, se preferisci, copia e incolla il codice qui sotto',
  'pix.timeLeft': 'Il tempo per pagare scade tra:',
  'pix.realtime': 'Aggiornato in tempo reale',

  'thanks.confirming.title': 'Conferma del pagamento in corso',
  'thanks.confirming.description': 'Stiamo attendendo la conferma del pagamento prima di sbloccare l\'accesso.',
  'thanks.failed.title': 'Pagamento non confermato',
  'thanks.failed.description': 'Non siamo riusciti a confermare il pagamento. Riprova o contatta l\'assistenza.',
  'thanks.success.title': 'Congratulazioni!',
  'thanks.success.subtitle': 'Ti sei abbonato a {productName}',
  'thanks.success.emailSent': 'Ti abbiamo inviato un\'email con il link di accesso alla piattaforma.',
  'thanks.success.emailMissing': 'Non hai ancora ricevuto l\'email?',
  'thanks.success.emailDelay': 'L\'email di registrazione di solito arriva entro 5 minuti.',
  'thanks.success.spamSupport': 'Se è passato più tempo, controlla nella cartella spam oppure invia un messaggio al canale di assistenza.',
  'thanks.success.supportButton': 'L\'email non è ancora arrivata',

  'method.creditCard': 'Carta di credito',
  'method.pix': 'PIX',

  'input.fullName.placeholder': 'Inserisci il nome completo',
  'input.phone.placeholder': 'Numero di cellulare',
  'input.country.searchPlaceholder': 'Cerca paese',
  'input.date.label': 'Data',
  'input.date.placeholder': 'gg/mm/aaaa',
  'input.cpf.placeholder': '000.000.000-00',
  'input.money.label': 'Importo',
  'input.money.placeholder': '0,00 €',
  'input.cnpj.label': 'Partita IVA',
  'input.cnpj.placeholder': '00.000.000/0000-00',
  'input.email.placeholder': 'email@esempio.com',
  'input.cardNumber.label': 'Numero della carta',
  'input.cardNumber.placeholder': '0000 0000 0000 0000',

  'address.label': 'Indirizzo',
  'address.placeholder': 'Cerca il tuo indirizzo',
  'address.noOptions': 'Nessun indirizzo trovato',
  'address.number.label': 'Numero',
  'address.number.placeholder': 'N.',
  'address.complement.label': 'Interno',
  'address.complement.placeholder': 'Interno, scala...',
  'address.neighborhood.label': 'Quartiere',
  'address.zipcode.label': 'CAP',
  'address.zipcode.placeholder': '00000',
  'address.city.label': 'Città',
  'address.state.placeholder': 'Prov.',

  'stripe.error.generic': 'Si è verificato un errore durante l\'elaborazione del pagamento, controlla i dati inseriti e riprova',
  'stripe.error.incompleteCard': 'Inserisci i dati della carta per continuare',
  'stripe.error.confirmPayment': 'Si è verificato un errore durante la conferma del pagamento',
  'stripe.submit': 'Conferma pagamento',

  'payment.error.generic': 'Si è verificato un errore durante l\'elaborazione del pagamento, controlla i dati inseriti e riprova',
  'payment.error.prepare': 'Si è verificato un errore durante la preparazione del pagamento, controlla i dati inseriti e riprova',
  'payment.error.missingCharge': 'Identificatore dell\'addebito non restituito',
  'payment.error.notApproved': 'Pagamento non approvato. Controlla i dati della carta e riprova.',

  'validation.cardNumber': 'Numero della carta non valido',
  'validation.cardExpiration': 'Data di scadenza non valida',
  'validation.cardExpired': 'Carta scaduta',
  'validation.cardCvv': 'CVV non valido',
  'validation.cpf': 'CPF non valido',
  'validation.fullName': 'Nome completo non valido',
  'validation.fullNameLettersOnly': 'Il nome deve contenere solo lettere',
  'validation.emailRequired': 'L\'email è obbligatoria',
  'validation.emailInvalid': 'Email non valida',
  'validation.phoneRequired': 'Il telefono è obbligatorio',
  'validation.phoneInvalid': 'Telefono non valido',
  'validation.phoneDigits': 'Il telefono deve avere 10 o 11 cifre',
  'validation.phoneMobileStartsWithNine': 'Il cellulare deve iniziare con 9',
  'validation.phoneDdd': 'Prefisso non valido',

  'interval.week.adjective': 'Settimanale',
  'interval.month.adjective': 'Mensile',
  'interval.bimonthly.adjective': 'Bimestrale',
  'interval.quarterly.adjective': 'Trimestrale',
  'interval.semiannual.adjective': 'Semestrale',
  'interval.year.adjective': 'Annuale',
  'interval.lifetime.adjective': 'A vita',
  'interval.week.noun': 'Settimana',
  'interval.month.noun': 'Mese',
  'interval.bimonthly.noun': 'Bimestre',
  'interval.quarterly.noun': 'Trimestre',
  'interval.semiannual.noun': 'Semestre',
  'interval.year.noun': 'Anno',
  'interval.lifetime.noun': 'A vita',
  'interval.lifetime.access': 'accesso a vita',
  'interval.period': 'periodo',

  'month.01': 'Gennaio',
  'month.02': 'Febbraio',
  'month.03': 'Marzo',
  'month.04': 'Aprile',
  'month.05': 'Maggio',
  'month.06': 'Giugno',
  'month.07': 'Luglio',
  'month.08': 'Agosto',
  'month.09': 'Settembre',
  'month.10Label': 'Ottobre',
  'month.11Label': 'Novembre',
  'month.12': 'Dicembre',
};

export default itIT;
